/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

/**
 * A link rendered in the footer's link row.
 */
export interface FooterLink {
	href: string;
	label: Mithril.Children;
}

export default class CustomFooter extends Component<Record<string, never>> {
	oninit(vnode: Mithril.Vnode<Record<string, never>, this>) {
		super.oninit(vnode);
	}

	getFooterLinks(): FooterLink[] {
		return [];
	}

	getInstagramUrl(): string {
		return '#';
	}

	/**
	 * Items rendered next to the quote, e.g. stats added by other extensions.
	 */
	statsItems(): ItemList<Mithril.Children> {
		return new ItemList<Mithril.Children>();
	}

	view() {
		const instagramUrl = this.getInstagramUrl();
		const footerLinks = this.getFooterLinks();
		return (
			<div className="CustomFooter">
				<div className="container">
					<span className="BCQuote opening" />
					{this.statsItems().toArray()}
				</div>
				<div className="container">
					<div className="CustomFooter-links">
						<div className="CustomFooter-socialLinks">
							<span>
								{icon('fab fa-instagram')}
								<a href={instagramUrl} target="_blank" rel="noopener">
									Instagram
								</a>
							</span>
						</div>
						<span>
							Built with ♥️ by{' '}
							<a target="_blank" rel="noopener" href="https://glowingblue.com/">
								Glowing Blue AG
							</a>
						</span>
					</div>
					<div className="CustomFooter-links">
						{footerLinks.map((link) => (
							<span>
								<a href={link.href}>{link.label}</a>
							</span>
						))}
					</div>
				</div>
			</div>
		);
	}
}
